import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

//import LABELESPECIAL from '../../../business-const/Label/LabelEspecial'

import MESSAGE from '../../../business-const/Message/Message'

import {
    formataPerc,
    formataTableCellHeadExibeDadosTexto,
    formataTableCellHeadExibeDadosValor,
    formataTableCellBodyExibeDadosTexto,
    formataTableCellBodyExibeDadosValor,
} from '../../../business-components/Formata/Formata'

import {
    DivOverflowX,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    //GridItem8,
    GridItem11,
} from '../../../business-components/Grid/Grid'

//import {
//    CardGridEstudo,
//} from '../../../business-components/Card/Card'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    anoPrimeiraLetraMaiscula,
    relatorioModoApresentacao,
} from './EstudoService'

//import {
//    CardGridEstudoTabelaPadrao,
//} from './EstudoComp'



const EstudoFormTabelaEvolucaoCancelamentoApolice = ( { values, estrategiasFinanceirasTabelaEvolucaoValorResgate, report,
    indInicial, indFinal } ) => {

    const TabelaEvolucaoCancelamentoApolice = () => {
        
        const aumentoLetraCabecalho = 4
        const aumentoLetraReportCabecalho = values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ? 3 : 5
        
        const aumentoLetra = 4
        const aumentoLetraReport = values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ? 4 : 6

        let headList = [
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosTexto(anoPrimeiraLetraMaiscula(), report, aumentoLetraCabecalho,
                    aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.idade, report, aumentoLetraCabecalho,
                    aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.valorPremioAnualizadoAcumulado, report,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.valorResgate, report, aumentoLetraCabecalho,
                    aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.valorSaldado, report, aumentoLetraCabecalho,
                    aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.beneficioProlongado, report, aumentoLetraCabecalho,
                    aumentoLetraReportCabecalho, values, true),
            },
        ]



        return (
            <>
                <TableExibeDados
                    report={report}
                    noMinW={true}
                >
                    <TableHeadExibeDados
                        report={report}
                    >
                        <TableRowHeadExibeDados
                            dados={headList}
                        />
                    </TableHeadExibeDados>

                    <TableBodyExibeDados>
                        {estrategiasFinanceirasTabelaEvolucaoValorResgate.tabelaEvolucaoValorResgate?.map((item, ind) => {
                            return (!indFinal || (ind >= indInicial && ind <= indFinal)) && (
                                <TableRowBodyExibeDados
                                    key={ind}
                                    report={report}
                                >
                                    <TableCellBodyExibeDados
                                        colSpan={headList[0].colSpan}
                                        primeiraColuna={true}
                                        bold={item.bold}
                                    >
                                        {formataTableCellBodyExibeDadosTexto(item.ano, report, item.bold,
                                            aumentoLetra, aumentoLetraReport, values)}
                                    </TableCellBodyExibeDados>
                                    
                                    <TableCellBodyExibeDados
                                        colSpan={headList[1].colSpan}
                                        bold={item.bold}
                                    >
                                        {formataTableCellBodyExibeDadosTexto(item.idadeFamiliarCotacao, report,
                                            item.bold, aumentoLetra, aumentoLetraReport, values)}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[2].colSpan}
                                        bold={item.bold}
                                    >
                                        {formataTableCellBodyExibeDadosValor(item.valorPremioAnualizadoAcumulado, report,
                                            item.bold, false, aumentoLetra, aumentoLetraReport, values)}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[3].colSpan}
                                        bold={item.bold}
                                    >
                                        {formataTableCellBodyExibeDadosValor(item.valorResgate, report, item.bold,
                                            false, aumentoLetra, aumentoLetraReport, values)}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[4].colSpan}
                                        bold={item.bold}
                                    >
                                        {formataTableCellBodyExibeDadosValor(item.valorSaldado, report, item.bold,
                                            false, aumentoLetra, aumentoLetraReport, values)}
                                    </TableCellBodyExibeDados>
                                    
                                    <TableCellBodyExibeDados
                                        colSpan={headList[5].colSpan}
                                        bold={item.bold}
                                    >
                                        {formataTableCellBodyExibeDadosTexto(item.beneficioProlongado, report,
                                            item.bold, aumentoLetra, aumentoLetraReport, values, true)}
                                    </TableCellBodyExibeDados>
                                </TableRowBodyExibeDados>
                            )
                        })}
                    </TableBodyExibeDados>
                </TableExibeDados>

                {values.aplicarTaxaInflacaoTabelaEvolucaoValorResgate &&
                !estrategiasFinanceirasTabelaEvolucaoValorResgate.apenasExibirTabelaEvolucaoValorResgateSemTaxaInflacao &&
                (!indFinal || indFinal >= estrategiasFinanceirasTabelaEvolucaoValorResgate.tabelaEvolucaoValorResgate.length - 1) && (
                    <div
                        className='mt-5'
                        dangerouslySetInnerHTML={{ __html:
                            MESSAGE().tabelaEvolucaoCancelamentoApoliceImportante.replace('$1$', formataPerc(values.taxaInflacaoAnual))}}
                    />
                )}
            </>
        )
    }

    return (
        estrategiasFinanceirasTabelaEvolucaoValorResgate.tabelaEvolucaoValorResgate.length > 0
            ?
                report || relatorioModoApresentacao(values)
                    ?
                        //<div
                        //    className={(!report && relatorioModoApresentacao(values) ? 'mt-10 ml-5 mr-5' : '')} // mudança da fonte: acrescentou mt-10
                        //>
                            <TabelaEvolucaoCancelamentoApolice/>
                        //</div>
                    :
                        /*<GridContainer
                            className='justify-center'
                        >
                            <GridItem8>
                                <CardGridEstudo>
                                    <CardGridEstudoTabelaPadrao
                                        values={values}
                                        SvgIcon={""}
                                        label={LABEL.tabelaEvolucaoCancelamentoApolice + ': ' +
                                            estrategiasFinanceirasTabelaEvolucaoValorResgate.nomeFamiliar
                                        }
                                        helpTextMorte={""}
                                        helpTextInvalidez={""}
                                        component={<TabelaEvolucaoCancelamentoApolice/>}
                                        popup={false}
                                    />
                                </CardGridEstudo>
                            </GridItem8>
                        </GridContainer>*/
                        <GridContainer
                            className='justify-center'
                        >
                            <GridItem11>
                                <DivOverflowX>
                                    <TabelaEvolucaoCancelamentoApolice/>
                                </DivOverflowX>
                            </GridItem11>
                        </GridContainer>
            :
                ''
    )
}

export default EstudoFormTabelaEvolucaoCancelamentoApolice